module.exports = __webpack_public_path__ + "files/802f94a154ecba7f4b359427cf19aae0.png";


//////////////////
// WEBPACK FOOTER
// ./images/close.png
// module id = 1371
// module chunks = 59